import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import styled from "styled-components";
import MainLayout from "./pages/layouts/MainLayout";
import BlankLayout from "./pages/layouts/BlankLayout";
// import OurProducts from "./pages/OurProducts";
import AppHomepage from "./pages/AppHomepage";
// import LaiyinlianqinTeacher from "./pages/LaiyinlianqinTeacher";
// import AboutUs from "./pages/AboutUs";
// import SocialResponsibility from "./pages/SocialResponsibility";
// import MoreApplications from "./pages/MoreApplications";
// import ShowAllIcon from "./pages/ShowAllIcons";
import Homepage from "./pages/Homepage";
import LaiYinSeries from "./pages/LaiYinSeries";
import LingGanSeries from "./pages/LingGanSeries";
import AppDetail from "./pages/AppDetail";

export default function App() {
  return (
    <Wrapper>
      <Routes>
        {/* 主布局 */}
        <Route element={<MainLayout />}>
          {/* 首页聚合两条品牌线的全部正文，避免爬虫只抓到空白壳或依赖客户端跳转 */}
          <Route path="/" element={<Homepage />} />
          <Route path="/laiyinSeries" element={<LaiYinSeries />} />
          <Route path="/lingganSeries" element={<LingGanSeries />} />
          {/* /curriculumSeries 已下架：导航与页脚都没有入口，也不在预渲染清单里，
              线上只会由 history fallback 返回首页 HTML，等于一条打不开的孤立路由，
              因此从路由表移除（页面组件保留在 src/pages/CurriculumSeries，将来要上线时
              同时补 prerenderRoutes 与导航入口） */}
          {/* 单个 App 的静态详情页：/app/<关键字>.html，内容与 App Store 商品页对齐，便于引擎直接读取 */}
          <Route path="/app/:slug" element={<AppDetail />} />
          {/* <Route path="/ourProducts" element={<OurProducts />} />
          <Route
            path="/laiyinlianqinTeacher"
            element={<LaiyinlianqinTeacher />}
          />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route
            path="/socialResponsibility"
            element={<SocialResponsibility />}
          />
          <Route path="/moreApplications" element={<MoreApplications />} />
          <Route path="/allIcons" element={<ShowAllIcon />} /> */}
        </Route>

        {/* 空白布局 */}
        <Route element={<BlankLayout />}>
          <Route path="/appHomepage" element={<AppHomepage />} />
        </Route>

        <Route path="*" element={<Navigate to="/laiyinSeries" />} />
      </Routes>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
`;
